import {
  LayoutDashboard,
  Users,
  BookOpen,
  Package,
  FileText,
  BarChart3,
  Settings as SettingsIcon,
  Store,
  ClipboardList,
} from "lucide-react";

export const navigationItems = {
  ADMIN: [
    { name: "Dashboard", href: "/stores/:storeId/dashboard", icon: LayoutDashboard },
    { name: "Suppliers", href: "/stores/:storeId/suppliers", icon: Users },
    { name: "Customers", href: "/stores/:storeId/customers", icon: Users },
    { name: "Ledger", href: "/stores/:storeId/ledger", icon: BookOpen },
    { name: "Inventory", href: "/stores/:storeId/inventory", icon: Package },
    { name: "Quotations", href: "/stores/:storeId/quotations", icon: ClipboardList },
    { name: "Invoices", href: "/stores/:storeId/invoices", icon: FileText },
    { name: "Reports", href: "/stores/:storeId/reports", icon: BarChart3 },
    { name: "Settings", href: "/stores/:storeId/settings", icon: SettingsIcon },
  ],
  SUPER_ADMIN: [
    { name: "Super Dashboard", href: "/super-dashboard", icon: LayoutDashboard },
    { name: "User Create", href: "/users/create", icon: Users },
    { name: "Store Management", href: "/stores", icon: Store },
  ],
};

export const defaultBusinesses = [
  { id: 1, name: "Main Business" },
  { id: 2, name: "Side Business" },
  { id: 3, name: "New Venture" },
];